import { IonCard, IonContent, IonPage } from '@ionic/react'
import React, { PropsWithChildren } from 'react'
import PublicAppBar from './components/PublicAppBar'

interface PublicWrapperProps {
	id?: string
}

const PublicWrapper: React.FC<PropsWithChildren<PublicWrapperProps>> = ({ children, id }) => {
	return (
		<IonPage>
			<IonContent className='relative [--ion-background-color:theme(colors.background.200.light)] dark:[--ion-background-color:theme(colors.background.100.dark)]'>
				<div className='absolute top-0 left-0 right-0 z-10'>
					<PublicAppBar />
					<div className='w-full h-[45vh] bg-gradient-to-b from-background-100-dark dark:from-black via-[percentage:69%] via-brand-primary-100-light dark:via-brand-primary-100-dark to-brand-primary-100-light dark:to-brand-primary-100-dark shadow-md clip-background' />
				</div>

				<div className='relative z-20 flex flex-col items-center justify-center py-[6.2rem] px-[1.4rem] min-h-screen overflow-auto'>
					<IonCard
						className='p-[2rem] text-text-dark dark:text-white bg-white dark:bg-[#063a3e] border border-brand-secondary-200-light dark:border-brand-secondary-100-dark max-w-[1400px] min-w-400px w-70vw lg:w-[60vw] xl:w-[50vw] 2xl:w-[40vw]'
						id={id}
					>
						{children}
					</IonCard>
				</div>
			</IonContent>
		</IonPage>
	)
}

export default PublicWrapper
